// Adds the social proof badge to cards that Unbxd draws (collection and search pages).
// Liquid cards and the JavaScript card template carry the same rules; this covers the Unbxd template.
(function () {
  var PRIORITY = [
    { tag: 'low-stock', label: 'Low stock', cls: 'is-low-stock' },
    { tag: 'back-in-stock', label: 'Back in stock', cls: 'is-back-in-stock' },
    { tag: 'trending', label: 'Trending', cls: 'is-trending' },
    { tag: 'best-seller', label: 'Best seller', cls: 'is-best-seller' },
    { tag: 'new', label: 'New', cls: 'is-new' },
  ];

  function pick(tags) {
    var lower = (tags || []).map(function (t) {
      return String(t).toLowerCase();
    });
    if (lower.indexOf('sale') > -1) {
      return null;
    }
    for (var i = 0; i < PRIORITY.length; i++) {
      if (lower.indexOf(PRIORITY[i].tag) > -1) {
        return PRIORITY[i];
      }
    }
    return null;
  }

  function badge(item) {
    var el = document.createElement('span');
    el.className = 'nn-product-preview-tag-item fs-12 fs-lg-14 fw-500 mz-proof ' + item.cls;
    el.textContent = item.label;
    return el;
  }

  function addTo(host, item, listClass, ref, after) {
    var list = host.querySelector('.nn-product-preview-tag-list');
    if (!list) {
      list = document.createElement('div');
      list.className = 'nn-product-preview-tag-list ' + listClass;
      if (ref && after) {
        host.insertBefore(list, ref.nextSibling);
      } else if (ref) {
        host.insertBefore(list, ref);
      } else {
        host.appendChild(list);
      }
    }
    var old = list.querySelector('.new-arrivals');
    if (old) {
      old.parentNode.removeChild(old);
    }
    list.insertBefore(badge(item), list.firstChild);
  }

  function enhance() {
    var state = window.unbxdSearch && window.unbxdSearch.state;
    var products = state && state.responseObj && state.responseObj.response && state.responseObj.response.products;
    if (!products || !products.length) {
      return;
    }
    var byId = {};
    products.forEach(function (p) {
      byId[String(p.uniqueId)] = p;
    });
    document.querySelectorAll('.nn-product-grid .product-item[data-id]:not([data-mz-badge])').forEach(function (card) {
      var product = byId[card.getAttribute('data-id')];
      if (!product) {
        return;
      }
      card.setAttribute('data-mz-badge', '1');
      var item = pick(product.tags);
      if (!item) {
        return;
      }
      var details = card.querySelector('.nn-product-preview-details');
      if (details) {
        addTo(details, item, 'mb-10', details.firstElementChild);
      }
      var hoverImage = card.querySelector('.nn-product-preview-hover .nn-product-preview-image');
      if (hoverImage) {
        addTo(hoverImage, item, 'd-none d-lg-flex', hoverImage.querySelector('a'), true);
      }
    });
  }

  var queued = false;
  function schedule() {
    if (queued) {
      return;
    }
    queued = true;
    window.setTimeout(function () {
      queued = false;
      enhance();
    }, 50);
  }

  function start() {
    var grid = document.querySelector('.nn-product-grid');
    if (!grid || !window.MutationObserver) {
      return;
    }
    new MutationObserver(schedule).observe(grid, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
